module.exports = __webpack_public_path__ + "static/media/ic_bano_seleccionado.e081b345.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/services/ic_bano_seleccionado.webp
// module id = 176
// module chunks = 1